import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class DataService {
  private userData: any = new BehaviorSubject('');
  _getUserData = this.userData.asObservable();

  private userAccessRoles: any = new BehaviorSubject('');
  _getUserAccessRoles = this.userAccessRoles.asObservable();

  _userId!: any;
  _userIsSuperAdmin: any;
  _userIsEMS: any;

  constructor(
  ) {}

  gettingLocalStorageKeys(key: any): any {
    let ele: any; 
    let keys = Object.keys(localStorage);
    return keys.find((k: any) => k  == key);
  }
}
